// extracted by mini-css-extract-plugin
export var errorIcon = "_jy-1";
export var nameLogo = "_jy-0";